import barba from '@barba/core';
import { gsap } from 'gsap';
import { replaceBodyClasses, scrollPosition, wait } from './helpers';
import { $Elements, BrowserEvents, Classes, Elements, TransitionDurations } from './constants';
import { enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';

;(function($) {

	// ---------- Barba Initialisation ----------

	barba.init({
		debug: false,
		preventRunning: true,
		prevent: ({ el }) => !$(el).is('a:not([target="_blank"]):not([href*="#"]):not([href^="mailto:"]):not([href^="tel:"]):not(.void-link):not([download]):not([href=""]):not([hreflang]):not([class*="lightbox"])'),
		transitions: [{
			sync: true,
			once: async() => $Elements.window.on('load', pageLoaded),
			enter: async() => $Elements.document.one(BrowserEvents.page.transition, pageLoaded),
			leave: async(data) => {

				document.documentElement.classList.remove('is-first-load');

				Elements.LoadingBar.classList.add(Classes.loading);
				Elements.LoadingOverlay.classList.add(Classes.loading);
				document.body.classList.add(Classes.leaving);
				data.current.container.classList.add(Classes.leaving);

				await defaultTransition(data);

				return true;
			},
			after: async(data) => {

				window.scrollTo(0, 0);

				replaceBodyClasses(data.next);

				$('.transition-clone').remove();

				$Elements.document.trigger(BrowserEvents.page.transition);

				return true;
			}
		}]
	});

	// ---------- Transitions ----------

	async function defaultTransition(data) {

		const scroll = scrollPosition();
		data.next.container.style.top = scroll.scrollTop + 'px';

		const nextMenu = data.next.container.querySelector('.menu-wrapper');
		nextMenu.classList.add(Classes.hidden);

		if(document.body.classList.contains(Classes.menuOpen)) {
			document.body.classList.remove(Classes.menuOpen);
			enableBodyScroll(Elements.MenuWrapper);

			await wait(TransitionDurations.default / 2);
		}

		await wait(TransitionDurations.default);

		gsap.set(data.current.container, { opacity: 0 });

		await wait(100);

		window.scrollTo(0, 0);
		data.next.container.style.top = 0;

		nextMenu.classList.remove(Classes.hidden);

		return true;
	}

	async function pageLoaded() {

		$Elements.document.trigger(BrowserEvents.page.enter);
		Elements.MainWrapper.classList.remove(Classes.loading);
		Elements.LoadingBar.classList.remove(Classes.loading);
		Elements.LoadingOverlay.classList.remove(Classes.loading);
		Elements.HeaderWrapper.classList.add(Classes.active);

		const heroSection = document.querySelector('.hero-section, .hero-section-light');

		if(heroSection) {

			heroSection.classList.add(Classes.active);

			const heroSectionContent = heroSection.querySelector('.content .content-inner');

			if(heroSectionContent) {

				[...heroSectionContent.children].map(async(item, index) => {
					await wait(100 * index);
					item.classList.add(Classes.active);
				});
			}
		}

		const tastingSection = document.querySelector('.tasting-section');

		if(tastingSection) {
			document.dispatchEvent(new Event('reservation.init'));
		}

		return true;
	}

}(jQuery));
